import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../src/utils/axiosInstance';
import Skeleton from '@mui/material/Skeleton';
import DOMPurify from 'dompurify';
import ConfigDOMPurify from '../config/DOMP';

const useQuery = () => new URLSearchParams(useLocation().search);

export default function S3Service(props) {
  const { userInfo } = props;
  const query = useQuery();
  const itemID = query.get('itemID');
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (userInfo && userInfo.userNTID) {
      getData();
    }
  }, [userInfo]);

  const getData = () => {
    const getFulfillmentDataUrl = '/api/v1/fulfillment/s3service/details';

    axiosInstance
      .get(getFulfillmentDataUrl, {
        params: {
          userNTID: userInfo?.userNTID,
          itemID: itemID
        }
      })
      .then((response) => {
        if (response.data) {
          const details = response.data?.password.replace(/\\n/g, '<br/>');
          setData(details);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderInfo = () => {
    if (data) {
      return (
        <div className="text-center">
          <div className="text-center">
            <div className="text-4xl font-Bosch_sans_bold">Fulfillment</div>
          </div>
          <div className="pt-5 text-center">
            <div className="font-Bosch_sans_bold bg-yellow-200">
              <p>
                Note: Please copy and save below S3 access details separately in
                your documentation.
              </p>
              <p>
                This link will be active for next 30 days, after which this link
                will be deactivated.
              </p>
            </div>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                data,
                ConfigDOMPurify.DOMPurifyConfiguration
              )
            }}
            className="font-Bosch_sans_light"
          ></div>
        </div>
      );
    } else {
      return (
        <>
          <div className="text-center">
            <div className="font-bold text-3xl">Item not found</div>
          </div>
          <div>&nbsp;</div>
          <div className="flex justify-center">
            <div
              className="py-5 px-10 mx-auto bg-slate-200"
              data-cy="not-found-notes"
            >
              <div className="font-bold p-3">Possible Causes</div>
              <ul className="list-disc p-3" data-cy="list-causes">
                <li>
                  Access is only possible for the initiator and the customer of
                  the original request in ITSP.
                </li>
                <li>
                  This information may no longer be available. All records are
                  purged after 30 days of request closure.
                </li>
              </ul>
              <div className="text-center font-bold p-3" data-cy="hotlineNote">
                Please contact IT Service Desk for any further assistance.
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  if (isLoading) {
    return (
      <div>
        <Skeleton
          variant="rectangular"
          width={2100}
          height={600}
          style={{ marginTop: '18px' }}
        />
      </div>
    );
  }

  return (
    <div className="s3StorageRoot">
      <div id="s3storageContainer" className="mt-32">
        {renderInfo()}
      </div>
    </div>
  );
}
